// utils
import { toDisplayPercentage } from "@pages/InventoryPage/modules/InventorySummary/components/shared/BonusCard/utils";
import { formatPrice } from "@utils/formatPrice.utils";
import { TooltipInfo } from "@shared/TooltipInfo/TooltipInfo";

// interfaces
import {
  ModelResult,
  PredictionPublicationPrice,
} from "../interfaces/interfaces";

interface Props {
  data: PredictionPublicationPrice;
  options: ModelResult;
}

export const VIMChangeCard = ({ data, options }: Props) => {
  return (
    <div className="mt-2 change-card">
      <div className="d-flex gap-2 justify-content-between">
        <div>
          <div>Variación %: {toDisplayPercentage(data.cambio_porcentual)}%</div>
          <div>Variación $: {formatPrice(data.cambio_bruto)}</div>
        </div>
        <div>
          <div>Clicks 15 días antes: {options.clicks_15_dias_antes}</div>
          <div>Visitas 15 días antes: {options.visitas_15_dias_antes}</div>
          <div className="d-flex gap-2">
            Visitas para promesa: {options.visitas_para_promesa}
            <TooltipInfo
              message="Mediana de visitas que se registran en los 15 días previos a una venta en esta zona."
              placement="top"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
